import { EventDto } from '@diritto/common/event/dtos/event.dto';
import { Color } from '@diritto/common/style/color';
import { Typography } from '@diritto/common/style/typography';
import { convertToDotString } from '@diritto/common/utils/date';
import styled from '@emotion/styled';
import { Divider } from 'ui-components/common/Divider';
import { EmptyList } from 'ui-components/common/EmptyList';
import { Link } from 'ui-components/common/Link';

interface EventListProps {
  events: EventDto[];
  emptyText: string;
}

export const EventList = ({ events, emptyText }: EventListProps) => {
  const getEventDateText = (event: EventDto) =>
    event.isInfinite
      ? '상시 진행'
      : `${convertToDotString(event.startAt, false)} ~ ${convertToDotString(event.endAt, false)}`;

  if (events.length === 0) {
    return <EmptyList description={emptyText} />;
  }

  return (
    <ul>
      {events.map(event => (
        <li key={event.id}>
          <Link href={`/events/${event.id}`}>
            <StylesItem>
              <StylesTitle>{event.title}</StylesTitle>
              <StylesDate>{getEventDateText(event)}</StylesDate>
              <Divider position="bottom" color={Color.Gray200} />
            </StylesItem>
          </Link>
        </li>
      ))}
    </ul>
  );
};

const StylesItem = styled.div`
  width: 100%;
  height: 81px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
`;

const StylesTitle = styled.p`
  ${Typography.XSmall}
  margin-bottom: 4px;
`;

const StylesDate = styled.p`
  ${Typography.XXXSmall}
  color: ${Color.Gray500};
`;
